// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';

import Vue from 'vue';
import Axios from 'axios';
import App from './App';
import router from '@/app/router';
import VuexRouterSync from 'vuex-router-sync';
// import VeeValidate from 'vee-validate';
// import dict from 'vee-validate/dist/locale/nl';
// import attr from '@/app/i18n';

import store from '@/app/store';
import plugins from '@/app/plugins';

// VeeValidate.Validator.extend( 'date_valid', {
//     getMessage: field => 'The ' + field + ' value is not truthy.',
//     validate: value =>
//     {
//         let parts = value.split( '-' );
//         let day = parseInt( parts[ 2 ] );
//         let month = parseInt( parts[ 1 ] - 1 );
//         let year = parseInt( parts[ 0 ] );
//         let date = new Date( year, month, day, 0, 0, 0 );

//         return day === date.getDate() && month === date.getMonth() && year === date.getFullYear();
//     }
// });

Vue.use( plugins );
// Vue.use( VeeValidate, {
//     events: 'blur'
// });

// VeeValidate.Validator.localize( 'nl', Object.assign( dict, attr.nl ) );

VuexRouterSync.sync( store, router );

Axios.defaults.baseURL = window._rootData.apiUrl;
Axios.defaults.headers.common.Accept = 'application/json';
Axios.interceptors.response.use(
    response => response,
    ( error ) =>
    {
        return Promise.reject( error );
    }
);

Vue.$http = Axios;
Object.defineProperty( Vue.prototype, '$http', {
    get()
    {
        return Axios;
    }
});

Vue.config.productionTip = false;

if( !window.dataLayer )
{
    window.dataLayer = window.dataLayer || [];
}

/*
SETTING AB
*/

store.dispatch( 'setABTest', 'B' );

/* if( Math.random() < 0.5 )
{
    store.dispatch( 'setABTest', 'A' );
}
else
{
    store.dispatch( 'setABTest', 'B' );
} */

// store.dispatch( 'knownPlayer', window._rootData.r );

require( 'slick-carousel/slick/slick.css' );
require( 'slick-carousel/slick/slick-theme.css' );

require( 'modern-normalize/modern-normalize.css' );

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js